var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Type, useSession } from '@lendi/lala-react';
import React, { useEffect } from 'react';
import { getThreads } from '../../../apis/getThreads';
import { ChatPanels } from '../../../types';
import CommPanelLoader from '../../Loader';
import { ChatHeader } from '../../ChatHeader';
import { Thread } from '../Threads/Thread';
var REFRESH_INTERVAL_MS = 1000;
export var Threads = function (_a) {
    var channelId = _a.channelId, onSelectThread = _a.onSelectThread, activePanel = _a.activePanel, onClose = _a.onClose;
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var session = useSession();
    var isTeamView = session.type === Type.Team;
    var _c = React.useState({ threads: [] }), threadsResponse = _c[0], setThreadsResponse = _c[1];
    useEffect(function () {
        var fetchThreads = function () { return __awaiter(void 0, void 0, void 0, function () {
            var getThreadFailed, threads;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        getThreadFailed = false;
                        return [4 /*yield*/, getThreads(session, function (error) {
                                getThreadFailed = true;
                                console.error('Error fetching threads:', error);
                            })];
                    case 1:
                        threads = (_a.sent()).threads;
                        setThreadsResponse({ threads: threads });
                        if (threads.length === 1) {
                            // as there is only one thread, so that will become default active selected thread
                            onSelectThread(threads[0]);
                        }
                        if (getThreadFailed) {
                            setTimeout(fetchThreads, REFRESH_INTERVAL_MS);
                        }
                        setLoading(getThreadFailed);
                        return [2 /*return*/];
                }
            });
        }); };
        if (session.identity && activePanel === ChatPanels.Threads) {
            fetchThreads();
        }
    }, [session.identity, activePanel]);
    return loading ? (React.createElement(CommPanelLoader, null)) : threadsResponse.threads.length > 1 ? (React.createElement("span", { "data-testid": "threads-component" },
        React.createElement(ChatHeader, { activePanel: ChatPanels.Threads, showBackArrow: !isTeamView, onClose: onClose }),
        threadsResponse.threads.map(function (ug) { return (React.createElement(Thread, { key: ug.userGroupHash, userGroup: ug, highlighted: channelId === ug.userGroupHash, lastMessage: ug.lastMessage.content, names: ug.customers.map(function (c) { return c.firstName; }), lastMessageDatetimeUTC: ug.lastMessage.utcDateTime, UnreadMessageCount: ug.unreadMessageCount, onSelected: function (ug) { return onSelectThread(ug); } })); }))) : (React.createElement(React.Fragment, null));
};
//# sourceMappingURL=index.js.map